module.exports = __webpack_public_path__ + "img/132-Fenstergrau SFTN Mat.jpg";